(() => {
'use strict';
function init(root){
if(root.dataset.initialized)return;root.dataset.initialized='true';
const controller=new AbortController(),signal=controller.signal;root.cleanup=()=>{controller.abort();root.querySelector('[data-quality-gallery]')?.cleanupQuality?.();document.body.classList.remove('bpl-store-menu-open','bpl-dialog-open');};
const listen=(target,type,handler,options={})=>target.addEventListener(type,handler,{...options,signal});
const $=selector=>root.querySelector(selector),$$=selector=>[...root.querySelectorAll(selector)];
const {patterns,materials,categories}=JSON.parse($('[data-bpl-library]').textContent);
const texts=JSON.parse($('[data-bpl-text]').textContent);
const T=(key,values={})=>(texts[key]||key).replace(/\{\{\s*(\w+)\s*\}\}/g,(_,name)=>values[name]??'');
 const closeNavigation = () => window.PoptexStoreChrome?.close(false);
  const brief = $('#brief-form');
  const briefSelection = {};
  let focusOrigin;
  const closeMenu = () => closeNavigation(false);
  function openDialog(dialog, trigger) { focusOrigin = trigger || document.activeElement; closeMenu(); dialog.showModal(); document.body.classList.add('bpl-dialog-open'); }
  function openBrief(trigger, selection = {}) {
    $('#brief-status').textContent = '';
    Object.assign(briefSelection, selection);
    const summary = $('.brief-selection');
    summary.textContent = [
      briefSelection.material && T("material_direction_171ce4") + briefSelection.material,
      briefSelection.pattern && T("design_direction_22eaad") + briefSelection.pattern
    ].filter(Boolean).join(' · ');
    summary.hidden = !summary.textContent;
    // A gallery close event must not restore focus over the inline form.
    focusOrigin = null;
    closeMenu();
    brief.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
    brief.elements.brand.focus({ preventScroll: true });
  }
  const ui = { openDialog, openBrief };
  $$('[data-open-brief]').forEach(button => button.addEventListener('click', event => { event.preventDefault(); openBrief(button); }));
  $$('[data-open-collection-brief]').forEach(button => button.addEventListener('click', () => {
    $('#collection-brief-status').textContent = '';
    openDialog($('#brief-dialog'), button);
  }));
  $$('dialog').forEach(dialog => {
    dialog.querySelector('[data-close-dialog]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', e => { if (e.target === dialog) { const r = dialog.getBoundingClientRect(); if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) dialog.close(); } });
    dialog.addEventListener('close', () => { if (!$('dialog[open]')) { document.body.classList.remove('bpl-dialog-open'); if (focusOrigin?.isConnected) focusOrigin.focus({ preventScroll: true }); } });
  });
  const credentialCards = $$('[data-credential-card]');
  const credentialPanels = $$('[data-credential-panel]');
  let credentialOrder = [...credentialCards];
  function selectCredential(card) {
    if (credentialOrder[0] === card) return;
    credentialOrder = [card, ...credentialOrder.filter(other => other !== card)];
    credentialOrder.forEach((item, index) => {
      item.style.setProperty('--credential-order', String(index));
      item.setAttribute('aria-pressed', String(index === 0));
    });
    credentialPanels.forEach(panel => panel.setAttribute('aria-hidden', String(panel.dataset.credentialPanel !== card.dataset.credentialCard)));
  }
  credentialCards.forEach(card => card.addEventListener('click', () => selectCredential(card)));
  const qualityRoot = $('[data-quality-gallery]');
  const qualityTabs = $$('[data-quality-tab]');
  const qualityPanels = $$('[data-quality-panel]');
  const qualityStates = qualityPanels.map(panel => {
    const track = panel.querySelector('[data-quality-track]');
    const dots = [...panel.querySelectorAll('[data-quality-dot]')];
    const photos = [...track.querySelectorAll('[data-customization-image]')];
    const status = panel.querySelector('[data-quality-status]');
    const total = track.children.length;
    const state = { panel, track, dots, status, total, index:0 };
    function paint() {
      dots.forEach((dot,index) => dot.setAttribute('aria-pressed',String(index === state.index)));
      photos.forEach((photo,index) => { photo.tabIndex = index === state.index ? 0 : -1; });
      const announcement = track.children[state.index].getAttribute('aria-label');
      if(status.textContent !== announcement)status.textContent = announcement;
    }
    state.goTo = index => {
      state.index = Math.max(0,Math.min(total - 1,index));
      track.scrollTo({left:state.index * track.clientWidth,behavior:'instant'});
      paint();
    };
    track.addEventListener('scroll', () => {
      if(panel.hidden || !track.clientWidth)return;
      state.index = Math.max(0,Math.min(total - 1,Math.round(track.scrollLeft / track.clientWidth)));
      paint();
    },{passive:true});
    track.addEventListener('keydown', event => {
      if(!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;
      event.preventDefault();
      state.goTo(event.key === 'Home' ? 0 : event.key === 'End' ? total - 1 : state.index + (event.key === 'ArrowRight' ? 1 : -1));
      if(event.target?.matches('[data-customization-image]'))photos[state.index]?.focus({preventScroll:true});
    });
    let gesture, moved = false;
    track.addEventListener('pointerdown',event=>{gesture={id:event.pointerId,x:event.clientX,y:event.clientY};moved=false;});
    track.addEventListener('pointermove',event=>{if(gesture?.id===event.pointerId && Math.hypot(event.clientX-gesture.x,event.clientY-gesture.y)>10)moved=true;});
    track.addEventListener('pointerup',()=>{gesture=null;});
    track.addEventListener('pointercancel',()=>{gesture=null;moved=true;});
    track.addEventListener('click',event=>{if(moved && event.detail!==0){event.preventDefault();event.stopPropagation();}},true);
    dots.forEach((dot,index) => dot.addEventListener('click',()=>state.goTo(index)));
    if('ResizeObserver' in window){
      state.observer = new ResizeObserver(() => {if(!panel.hidden && track.clientWidth)state.goTo(state.index);});
      state.observer.observe(track);
    }
    paint();
    return state;
  });
  function selectQuality(tab) {
    if(tab.getAttribute('aria-selected') === 'true')return;
    qualityTabs.forEach(button => {
      const selected = button === tab;
      button.setAttribute('aria-selected',String(selected));
      button.tabIndex = selected ? 0 : -1;
    });
    qualityStates.forEach(state => {
      state.panel.hidden = state.panel.dataset.qualityPanel !== tab.dataset.qualityTab;
      if(!state.panel.hidden)state.goTo(0);
    });
  }
  qualityTabs.forEach((tab,index) => {
    tab.addEventListener('click',()=>selectQuality(tab));
    tab.addEventListener('keydown',event => {
      if(!['ArrowLeft','ArrowRight','ArrowUp','ArrowDown','Home','End'].includes(event.key))return;
      event.preventDefault();
      const next = event.key === 'Home' ? 0 : event.key === 'End' ? qualityTabs.length - 1 : (index + (['ArrowRight','ArrowDown'].includes(event.key) ? 1 : -1) + qualityTabs.length) % qualityTabs.length;
      selectQuality(qualityTabs[next]);qualityTabs[next].focus();
    });
  });
  let qualityLayoutObserver;
  const qualityLayout = $('.quality-layout');
  if (qualityLayout) {
    const nav = $('[data-gift-nav]');
    const tabs = $('.quality-tabs');
    const note = $('.quality-imagery-note');
    const captions = $$('.quality-slide figcaption');
    const paginations = $$('.quality-pagination');
    const outerHeight = element => {
      if (!element || !element.getClientRects().length) return 0;
      const style = getComputedStyle(element);
      return element.getBoundingClientRect().height + (parseFloat(style.marginTop)||0) + (parseFloat(style.marginBottom)||0);
    };
    const sizeQuality = () => {
      const controls = Math.max(0,...captions.map(outerHeight)) + Math.max(0,...paginations.map(outerHeight)) + outerHeight(note) + outerHeight(tabs);
      qualityLayout.style.setProperty('--quality-nav-height',`${Math.ceil(nav?.getBoundingClientRect().height || 76)}px`);
      qualityLayout.style.setProperty('--quality-controls-height',`${Math.ceil(controls)}px`);
    };
    if ('ResizeObserver' in window) {
      qualityLayoutObserver = new ResizeObserver(sizeQuality);
      [nav,tabs,note,...captions,...paginations].filter(Boolean).forEach(element=>qualityLayoutObserver.observe(element));
    }
    sizeQuality();
  }
  if (qualityRoot) qualityRoot.cleanupQuality = () => {
    qualityStates.forEach(state => state.observer?.disconnect());
    qualityLayoutObserver?.disconnect();
  };
  const customizationViewer = $('#customization-viewer');
  if (customizationViewer) {
    const detailImage = $('#customization-image');
    const detailStatus = $('#customization-status');
    let detailRequest = 0;
    $$('[data-customization-image]').forEach(button=>button.addEventListener('click',async () => {
      const ticket = ++detailRequest;
      const photo = button.querySelector('img');
      detailImage.hidden = true;
      detailImage.alt = photo.alt;
      detailStatus.textContent = '';
      openDialog(customizationViewer,button);
      customizationViewer.scrollTop = 0;
      try {
        await photo.decode();
        if(ticket!==detailRequest || !customizationViewer.open)return;
        const src = photo.currentSrc || photo.src;
        if(detailImage.src!==src)detailImage.src=src;
        await detailImage.decode();
        if(ticket!==detailRequest || !customizationViewer.open)return;
        detailImage.hidden = false;
        detailStatus.textContent = '';
      } catch {
        if(ticket===detailRequest && customizationViewer.open)detailStatus.textContent = T("this_image_could_not_be_loaded_close_this_view_3261ea");
      }
    }));
    customizationViewer.addEventListener('click',event=>{
      if(event.target===customizationViewer)customizationViewer.close();
    });
    customizationViewer.addEventListener('close',()=>{
      detailRequest++;detailImage.hidden=true;detailStatus.textContent='';
    });
    if(qualityRoot){
      const cleanupGallery = qualityRoot.cleanupQuality;
      qualityRoot.cleanupQuality = () => {
        cleanupGallery();detailRequest++;
        if(customizationViewer.open)customizationViewer.close();
      };
    }
  }
  const steps = $$('.process-steps details');
  steps.forEach(step => {
    step.querySelector('summary').addEventListener('click', event => { if (step.open) event.preventDefault(); });
    step.addEventListener('toggle', () => { if (step.open) steps.forEach(other => { if (other !== step) other.open = false; }); });
  });
  [brief, $('#collection-brief-form')].forEach(form => {
    const status = form.querySelector('[role="status"]');
    form.addEventListener('submit', event => {
      event.preventDefault();
      if (!form.reportValidity()) return;
      status.textContent = T("demo_only_your_brief_has_not_been_sent_bdbf90");
    });
    form.addEventListener('input', () => { status.textContent = ''; });
  });

  const cards = $$('[data-pattern]');
  const collapsibleGroups = $$('[data-pattern-collapsible]');
  const patternCount = $('#pattern-count');
  const patternMore = $('#pattern-more');
  const patternMoreLabel = patternMore?.querySelector('[data-pattern-more-label]');
  let patternsExpanded = false;
  function updatePatternCount() {
    const hiddenCategories = new Set(collapsibleGroups.filter(group=>group.hidden).map(group=>group.dataset.patternGroup));
    const shown = patterns.filter(pattern=>!hiddenCategories.has(pattern.category)).length;
    patternCount.textContent = patternCount.dataset.countFormat.replace('{shown}',String(shown)).replace('{total}',String(patterns.length));
  }
  updatePatternCount();
  if (patternMore) patternMore.addEventListener('click', () => {
    patternsExpanded = !patternsExpanded;
    collapsibleGroups.forEach(group => { group.hidden = !patternsExpanded; });
    updatePatternCount();
    patternMore.setAttribute('aria-expanded', String(patternsExpanded));
    patternMoreLabel.textContent = patternsExpanded ? patternMoreLabel.dataset.collapseLabel : patternMoreLabel.dataset.expandFormat.replace('{count}',String(collapsibleGroups.length));
    patternMore.querySelector('.showroom-arrow')?.classList.toggle('is-reversed', patternsExpanded);
    if (!patternsExpanded) {
      patternMore.focus({preventScroll:true});
      const bounds = patternMore.getBoundingClientRect();
      if (bounds.top < 0 || bounds.bottom > window.innerHeight) {
        patternMore.scrollIntoView({block:'nearest',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      }
    }
  });
  const gallery = $('#gallery-dialog');
  const image = $('#gallery-image');
  const compare = $('#compare-dialog');
  let active;
  let kind;
  let origin;
  let request = 0;
  let opening = 0;
  const loaded = new Map();
  function preload(src) {
    const url = new URL(src,document.baseURI).href;
    if (!loaded.has(url)) {
      const promise = new Promise((resolve,reject) => {
        const img = new Image();
        img.onload = () => img.decode().then(resolve).catch(resolve);
        img.onerror = reject;
        img.src = url;
      });
      loaded.set(url,promise);
      promise.catch(() => loaded.delete(url));
    }
    return loaded.get(url);
  }
  function resetZoom() {
    $('#gallery-zoom').classList.remove('is-zoomed');
    $('#gallery-zoom').setAttribute('aria-pressed','false');
    $('#gallery-zoom').setAttribute('aria-label',T("enlarge_image_47d107"));
    $('#zoom-label').textContent = T("tap_to_enlarge_47eafa");
  }
  async function setView(index) {
    const current = ++request;
    const item = active;
    const view = item.views[index];
    const status = $('#gallery-load-status');
    status.textContent = T("preparing_this_view_79d84e");
    image.setAttribute('aria-busy','true');
    try { await preload(view.image); } catch {
      if (current !== request) return;
      image.hidden = true;
      image.removeAttribute('aria-busy');
      status.textContent = T("this_view_could_not_be_loaded_please_choose_an_b9ed8f");
      return;
    }
    if (current !== request || item !== active) return;
    if (image.src !== new URL(view.image,document.baseURI).href) image.src = view.image;
    image.alt = view.alt;
    image.style.setProperty('--view-scale',String(view.crop?.scale || 1));
    image.style.setProperty('--view-origin',view.crop?.origin || '50% 50%');
    image.toggleAttribute('data-crop',Boolean(view.crop));
    image.hidden = false;
    image.removeAttribute('aria-busy');
    resetZoom();
    $$('#gallery-views button').forEach((button,i) => button.setAttribute('aria-pressed',String(i === index)));
    const source = kind === 'material' ? T("illustrative_material_view_4d43ef") : item.type === 'catalog' ? T("catalog_design_illustration_41ab8b") : T("illustrative_product_styling_c054d7");
    $('#gallery-view-note').textContent = `${source} · ${view.label}`;
    status.textContent = '';
  }
  function makeSpecs(rows) {
    $('#gallery-specs').replaceChildren(...rows.map(([label,value]) => {
      const row = document.createElement('div');
      const dt = document.createElement('dt'); dt.textContent = label;
      const dd = document.createElement('dd'); dd.textContent = value;
      row.append(dt,dd); return row;
    }));
  }
  async function show(item,type,trigger) {
    const ticket = ++opening;
    active = item;
    kind = type;
    origin = trigger;
    gallery.dataset.kind = type;
    $('#gallery-title').textContent = item.name;
    $('#gallery-description').textContent = item.description;
    $('#gallery-eyebrow').textContent = type === 'material' ? T("the_material_library_a_closer_look_640886") : T("the_pattern_library_design_study_97b100");
    $('#gallery-category').textContent = type === 'material' ? item.tagline.toUpperCase() : categories.find(c=>c[0]===item.category)[1].toUpperCase();
    const palette = $('#gallery-palette');
    palette.hidden = type === 'material';
    palette.replaceChildren(...(item.palette || []).map(colour => { const span = document.createElement('span'); span.style.setProperty('--swatch',colour); span.setAttribute('aria-label',colour); return span; }));
    if (type === 'material') {
      makeSpecs([[T("surface_0905f7"),item.face],[T("construction_9dc7e9"),item.build],[T("hand_feel_e29e9a"),item.feel],[T("collection_fit_500dd5"),item.direction],[T("composition_47fca4"),item.composition],[T("weight_gsm_e43de2"),item.weight]]);
      $('#gallery-source-note').textContent = T("ai_generated_material_concepts_confirm_appeara_f6ab41");
    } else {
      makeSpecs([[T("design_direction_172fa5"),categories.find(c=>c[0]===item.category)[1]],[T("collection_role_f7692d"),item.category === 'seasonal' ? T("seasonal_edition_6b405a") : item.category === 'brand' ? T("brand_signature_concept_3bd264") : T("core_or_seasonal_collection_104640")],[T("scale_repeat_de26bd"),T("refine_motif_scale_and_repeat_for_the_chosen_b_6c9921")],[T("material_pairing_7257da"),T("review_print_or_weave_suitability_for_the_sele_5cf4aa")]]);
      $('#gallery-source-note').textContent = T("ai_generated_blanket_design_concept_final_colo_417a22");
    }
    $('#gallery-views').replaceChildren(...item.views.map((view,i) => { const button = document.createElement('button'); button.type = 'button'; button.textContent = view.label; button.setAttribute('aria-pressed',String(i===0)); button.dataset.view = String(i); return button; }));
    $('#gallery-views').hidden = item.views.length < 2;
    await setView(0);
    if (active !== item || ticket !== opening) return;
    ui.openDialog(gallery,trigger);
    gallery.scrollTop = 0;
  }
  const blanketViewer = $('#blanket-viewer');
  const blanketImage = $('#blanket-viewer-image');
  cards.forEach(card => card.addEventListener('click', () => {
    const photo = card.querySelector('img');
    blanketImage.src = photo.currentSrc || photo.src;
    blanketImage.alt = photo.alt;
    ui.openDialog(blanketViewer,card);
  }));
  blanketViewer.addEventListener('click', event => {
    if (event.target === blanketViewer) blanketViewer.close();
  });
  $$('[data-series]').forEach(card => card.addEventListener('click', () => show(materials.find(m=>m.id===card.dataset.series),'material',card)));
  $('#gallery-views').addEventListener('click', event => { const button = event.target.closest('[data-view]'); if (button && button.getAttribute('aria-pressed') !== 'true') setView(Number(button.dataset.view)); });
  $('#gallery-zoom').addEventListener('click', () => {
    const zoomed = $('#gallery-zoom').classList.toggle('is-zoomed');
    $('#gallery-zoom').setAttribute('aria-pressed',String(zoomed));
    $('#gallery-zoom').setAttribute('aria-label',zoomed?T("reduce_image_3f914e"):T("enlarge_image_47d107"));
    $('#zoom-label').textContent = zoomed ? T("tap_to_reduce_0d9fc6") : T("tap_to_enlarge_47eafa");
  });
  gallery.addEventListener('close', () => { request++; opening++; resetZoom(); });
  $('#gallery-add-brief').addEventListener('click', () => {
    const selection = kind === 'material' ? { material:active.name } : { pattern:active.name };
    gallery.close();
    ui.openBrief(origin,selection);
  });
  $$('[data-open-compare]').forEach(button => button.addEventListener('click', () => { ui.openDialog(compare,button); compare.scrollTop = 0; }));
  $$('[data-compare-series]').forEach(button => button.addEventListener('click', () => {
    const id = button.dataset.compareSeries;
    compare.close();
    show(materials.find(m=>m.id===id),'material',$(`[data-series="${id}"]`));
  }));

}
const mount=scope=>{if(scope.matches?.('[data-bpl-showroom]'))init(scope);scope.querySelectorAll('[data-bpl-showroom]').forEach(init);};
if(!window.PoptexBrandShowroom){window.PoptexBrandShowroom={mount};document.addEventListener('shopify:section:load',event=>mount(event.target));document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('[data-bpl-showroom]').forEach(root=>root.cleanup?.()));}
mount(document);
})();
